// extracted by mini-css-extract-plugin
export default {"root":"SwipedGallery_root__Ey+dt","title":"SwipedGallery_title__c6a5P"};